export default __webpack_public_path__ + "static/media/graphics.e1b7857c.svg";